// @flow
import React from 'react'
import styled from 'styled-components'

type Props = {
  value: string,
  onChange: (s:string) => void
}

type State = {
  active: boolean,
  val: string
}

export default class Input extends React.Component<Props,State> {

  // $FlowFixMe
  input = React.createRef()

  state = {active: false, val: this.props.value}

  componentDidUpdate(){
    if(!this.state.active) return
    if(!this.input.current) return
    this.input.current.focus()
  }

  handleInputChange = (e:*) => {
    this.setState({ val: e.target.value })
  }

  handleBlur = () => {
    this.setState({ active: false })
    this.props.onChange(this.state.val)
  }

  render () {
    let {active, val} = this.state
    return (
      <Wrapper>
        {active || <Text onClick={() => this.setState({active: true})}>{this.props.value}</Text>}
        {active && <Update innerRef={this.input} value={val} onChange={this.handleInputChange} onBlur={this.handleBlur} />}
      </Wrapper>
    )
  }

}

const Wrapper = styled.div`
  font-size: 14px;
  width: 100%;
  height: 100%;
`

const Text = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

const Update = styled.input`
  text-align: center;
  font-size: 14px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  outline: none;
`


// WEBPACK FOOTER //
// ./src/components/Input.js